import { Box, PropertyCard } from '@zillow/constellation-10';
import React from 'react';
import PropertyCardPlaceholder from '../../../images/property_card_placeholder.png';
import BackgroundImage from '../../../images/onboarding_background.png';
import propertyUtils from '../../../utils/propertyUtils';
import { StyledBackground } from '../styles';

const PropertyCardPreview = ({ address = '', unit = '' }) => {
  const [street = '', city = '', stateAndZip = ''] = address.split(',');
  const [state = '', zip = ''] = stateAndZip.trim().split(' ');
  const { formattedCityStateZip, formattedCompleteAddress, formattedStreet } = propertyUtils.formatAddress({
    street: street.trim(),
    unit: unit.trim(),
    city: city.trim(),
    state: state.trim(),
    zip: zip.trim(),
  });

  return (
    <StyledBackground style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <Box css={{ maxWidth: '433px', margin: '0 auto' }}>
        <PropertyCard
          badge={<PropertyCard.Badge>New property</PropertyCard.Badge>}
          data={{
            dataArea1: <Box css={{ marginTop: '600', marginLeft: '200' }}>{formattedStreet}</Box>,
            dataArea2: <Box css={{ marginBottom: '600', marginLeft: '200' }}>{formattedCityStateZip}</Box>,
          }}
          photoBody={<PropertyCard.Photo src={PropertyCardPlaceholder} alt="placeholder property image" />}
          saveButton={<PropertyCard.SaveButton />}
        />
      </Box>
    </StyledBackground>
  );
};

export default PropertyCardPreview;
